// extracted by mini-css-extract-plugin
export default {"wrapper":"ParticipantSelector_wrapper__T0OA0"};